import Avatar, { type AvatarProps } from "@ch/components/Avatar";
import type { FC } from "react";

type UserAvatarProps = AvatarProps & {
  title?: string;
  subtitle?: string;
  imageLeft?: boolean;
  titleClassName?: string;
  subTitleClassName?: string;
};

const UserAvatar: FC<UserAvatarProps> = ({
  title,
  subtitle,
  imageLeft,
  titleClassName = "",
  subTitleClassName = "",
  ...props
}) => {
  const showTitlesContainer = title ?? subtitle;
  return (
    <div
      className={`flex items-center gap-3 ${
        imageLeft && "w-fit flex-row-reverse"
      }`}
    >
      {showTitlesContainer && (
        <div
          className={`flex flex-col gap-1 text-right ${
            imageLeft && "!text-left"
          }`}
        >
          <h4 className={titleClassName ?? "text-sm"}>{title}</h4>
          <p className={subTitleClassName ?? "text-sm"}>{subtitle}</p>
        </div>
      )}
      <Avatar {...props} />
    </div>
  );
};

export default UserAvatar;
